import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import CreateJob from './dto/CreateJob'
import GetJob from './dto/GetJob'
import {PagedJobResultRequestDto} from './dto/PagedJobResultRequestDto'
import UpdateJob from './dto/UpdateJob'
import GetAllJobs from './dto/GetAllJobs'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Job/Create`
export const URL_DELETE = `${API_URL}/Job/Delete`
export const URL_GET = `${API_URL}/Job/Get`
export const URL_GET_ALL = `${API_URL}/Job/GetPagedAll`
export const URL_GET_ALL_FOR_GRADUATES = `${API_URL}/Job/GetPagedAllForGraduates`
export const URL_GET_ALL_FOR_ADMIN = `${API_URL}/Job/GetPagedAllForAdmin`
export const URL_UPDATE_FOR_ADMIN = `${API_URL}/Job/UpdateForAdmin`
export const URL_UPDATE = `${API_URL}/Job/Update`

export function onCreateJob(createJob: CreateJob): Promise<boolean> {
  return axios.post(URL_CREATE, createJob)
}

export function onDeleteJob(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetJob(entityDto: EntityDto): Promise<GetJob> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllJobs(
  pagedFilterAndSortedRequest: PagedJobResultRequestDto
): Promise<PagedResultDto<GetAllJobs>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onGetPagedAllJobsForGraduates(
  pagedFilterAndSortedRequest: PagedJobResultRequestDto
): Promise<PagedResultDto<GetAllJobs>> {
  return axios.get(URL_GET_ALL_FOR_GRADUATES, {params: pagedFilterAndSortedRequest})
}

export function onGetPagedAllJobsForAdmin(
  pagedFilterAndSortedRequest: PagedJobResultRequestDto
): Promise<PagedResultDto<GetAllJobs>> {
  return axios.get(URL_GET_ALL_FOR_ADMIN, {params: pagedFilterAndSortedRequest})
}
export function onUpdateJob(updateJobInput: UpdateJob): Promise<boolean> {
  return axios.put(URL_UPDATE, updateJobInput)
}

export function onUpdateJobForAdmin(updateCompanyInput: UpdateJob): Promise<boolean> {
  return axios.put(URL_UPDATE_FOR_ADMIN, updateCompanyInput)
}
